import { IMetric } from '../interfaces/metric.interface';

export const HARDCODED_METRICS: IMetric[] = [
  { name: 'count', displayName: 'Count' },
];
